export enum ErinnerungsZeiten {
  AM_GLEICHEN_TAG = 'AM_GLEICHEN_TAG',
  EIN_TAG_ZUVOR = 'EIN_TAG_ZUVOR',
  EINE_WOCHE_ZUVOR = 'EINE_WOCHE_ZUVOR',
  ZWEI_WOCHEN_ZUVOR = 'ZWEI_WOCHEN_ZUVOR',
  VIER_WOCHEN_ZUVOR = 'VIER_WOCHEN_ZUVOR',
  SECHS_WOCHEN_ZUVOR = 'SECHS_WOCHEN_ZUVOR',
  DREI_MONATE_ZUVOR = 'DREI_MONATE_ZUVOR',
}
